module.exports = __webpack_public_path__ + "images/marketing/carousel_markers.png";